// extracted by mini-css-extract-plugin
export default {"melodyVideo":"TO-z","isFullWidth":"UO-z","landingPageVideo":"VO-z","play":"WO-z","iframeVideo":"XO-z","playHidden":"YO-z","fullwidth":"ZO-z"};